export const riverKeys = {
  LIBRARY_PICKS: 'library-picks',
  YOUR_REPORTS: 'your-reports',
  UPCOMING: 'upcoming',
  SEARCH: 'search',
  MY_FW: 'my-fw',
  EVENTS: 'events',
  STORY_WATCH: 'story-watch'
}

export const SPONSORED_HEADLINES_INTERVAL = 10
